exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (min-width: 992px) {\r\n\r\n    .departmentname {\r\n        width: 33% !important;\r\n    }\r\n    .doctorname {\r\n        width: 22% !important;\r\n    }\r\n    .datelabel  {\r\n        width: 18% !important;\r\n    }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/Booking/Template/Booking.css
// module id = 512
// module chunks = 3